module.exports = __webpack_public_path__ + "img/run4.82939ccf.svg";